import { Point } from "../Point";
import { Bounds } from "../../../utilities/BoundsObserver/Bounds";

/**
 * Gets the origin point for the specified bounds and alignment.
 * @param bounds The bounds to calculate the origin from.
 * @param alignment The alignment.
 * @returns The origin point for the given bounds and alignment, or null if cursor alignment.
 */
export function getOriginFromBounds(bounds: Bounds, alignment: "top" | "left" | "right" | "bottom"): Point {
  const { top, left, width, height } = bounds;

  switch (alignment) {
    case "top":
      return { x: left + width * 0.5, y: top };
    case "left":
      return { x: left, y: top + height * 0.5 };
    case "right":
      return { x: left + width, y: top + height * 0.5 };
    case "bottom":
      return { x: left + width * 0.5, y: top + height };
    default:
      return { x: 0, y: 0 };
  }
}
